/**
 * Разделение маркетингового SPA и кабинета (синхронно с AppContent в App.js).
 * @returns {boolean} true — домен/путь приложения (app.* или loopback с прикладным путём)
 */
import { isLoopbackHost } from './loopbackHost';

const IS_DEV = process.env.NODE_ENV === 'development';
const APP_SPA_HOSTNAMES = new Set([
  'kassa.markbase.ru',
]);

export function isAppDomain() {
  if (typeof window === 'undefined') return false;
  const hostname = window.location.hostname;
  const pathname = window.location.pathname;

  if (IS_DEV) {
    // eslint-disable-next-line no-console
    console.log('🔍 isAppDomain: проверка', {
      hostname,
      pathname,
      href: window.location.href
    });
  }

  if (hostname.startsWith('app.')) {
    if (IS_DEV) {
      // eslint-disable-next-line no-console
      console.log('✅ isAppDomain: домен приложения (app.*)');
    }
    return true;
  }

  if (APP_SPA_HOSTNAMES.has(hostname)) {
    if (IS_DEV) {
      // eslint-disable-next-line no-console
      console.log('✅ isAppDomain: модульный домен приложения');
    }
    return true;
  }

  if (hostname === 'markbase.ru' || hostname === 'www.markbase.ru') {
    if (IS_DEV) {
      // eslint-disable-next-line no-console
      console.log('✅ isAppDomain: публичный домен (markbase.ru)');
    }
    return false;
  }

  if (isLoopbackHost(hostname)) {
    const publicPaths = ['/', '/about', '/pricing', '/contact', '/company', '/privacy', '/terms', '/personal-data', '/cookies', '/docs', '/help'];
    const isPublicPath = publicPaths.includes(pathname) || pathname.startsWith('/docs/') || pathname.startsWith('/help/') || pathname.startsWith('/product/');
    const result = !isPublicPath;

    if (IS_DEV) {
      // eslint-disable-next-line no-console
      console.log('🔍 isAppDomain: loopback, публичный путь:', isPublicPath, 'это приложение:', result);
    }

    return result;
  }

  if (IS_DEV) {
    // eslint-disable-next-line no-console
    console.log('✅ isAppDomain: по умолчанию считаем публичным сайтом');
  }
  return false;
}
